import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

import {Constants} from '../config/constants.config';
import {NewsViewModel} from '../viewModels/news.viewModel';

@Injectable()
export class NewsService {

    constructor(
        private readonly httpClient: HttpClient,
        private readonly constants: Constants
    ) {
    }

    getNews(skip: number): Observable<NewsViewModel[]> {
        return this.httpClient.get<NewsViewModel[]>(`${this.constants.apiURL()}/news/`, {
            params: new HttpParams().set('skip', String(skip))
        });
    }

    getLatestNews(): Observable<NewsViewModel> {
        return this.httpClient.get<NewsViewModel>(`${this.constants.apiURL()}/news/latest/`);
    }

    getSingleNews(id: number): Observable<NewsViewModel> {
        return this.httpClient.get<NewsViewModel>(`${this.constants.apiURL()}/news/${id}/`);
    }

}
